import { MIME_TYPES } from './mimeTypes';

export const downloadBlobAsFile = (blob: Blob, filename: string): void => {
  const extension: string = filename.split('.').pop()?.toLowerCase() ?? '';

  // Auto-correct extension if blob type doesn't match filename extension
  if (
    MIME_TYPES[extension] &&
    blob.type &&
    blob.type !== MIME_TYPES[extension]
  ) {
    const correctExtension: string | undefined = Object.entries(
      MIME_TYPES,
    ).find(([_, mimeType]: [string, string]) => mimeType === blob.type)?.[0];
    if (correctExtension) {
      console.warn(
        `[downloadBlobAsFile] auto-correcting extension from .${extension} to .${correctExtension} (blob type: ${blob.type})`,
      );
      filename = filename.replace(`.${extension}`, `.${correctExtension}`);
    }
  }

  const downloadUrl: string = URL.createObjectURL(blob);
  const downloadLink: HTMLAnchorElement = document.createElement('a');
  downloadLink.href = downloadUrl;
  downloadLink.download = filename;
  document.body.appendChild(downloadLink);
  downloadLink.click();
  downloadLink.remove();
  setTimeout(() => URL.revokeObjectURL(downloadUrl), 1000);
};
